import { RuleProps } from 'types/application';

export const SHIP_OWNERS_PARTICULARS = 'ship-owners-particulars';
export const MMSI_NO_VERIFICATION = 'mmsi-no-verification';
export const STATION_INFORMATION = 'station-information';
export const OTHER_DETAILS = 'other-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_SSL_APPLICATION = [
    {
        sectionID: SHIP_OWNERS_PARTICULARS,
        sectionName: 'Ship Owner(s) Particulars',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'date-of-birth',
                label: 'Date of Birth',
                type: 'text'
            },
            {
                id: 'place-of-birth',
                label: 'Place of Birth',
                type: 'dropdown',
                apiID: 'CommonData'
            },
            {
                id: 'nationality',
                label: 'Nationality',
                type: 'text'
            },
            {
                id: 'residential-status',
                label: 'Residential Status',
                type: 'dropdown',
                apiID: 'CommonData'
            },
            {
                id: 'sex',
                label: 'Sex',
                type: 'dropdown',
                apiID: 'CommonData',
                span: 12
            },
            {
                id: 'is-there-a-co-owner',
                label: 'Is there a Co-Owner?',
                type: 'text',
                span: 12
            },
            {
                id: 'nric-fin',
                label: 'NRIC/FIN',
                type: 'text',
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'co-owners-name',
                label: "Co-Owner's Name",
                type: 'text',
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'co-owners-date-of-birth',
                label: 'Date of Birth',
                type: 'text',
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'co-owners-place-of-birth',
                label: 'Place of Birth',
                type: 'dropdown',
                apiID: 'CommonData',
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'co-owners-nationality',
                label: 'Nationality',
                type: 'text',
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'co-owners-residential-status',
                label: 'Residential Status',
                type: 'dropdown',
                apiID: 'CommonData',
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'co-owners-sex',
                label: 'Sex',
                type: 'dropdown',
                apiID: 'CommonData',
                span: 12,
                rule: {
                    baseIds: [`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${SHIP_OWNERS_PARTICULARS}-is-there-a-co-owner`] !== 'Yes');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: MMSI_NO_VERIFICATION,
        sectionName: 'MMSI No (DSC/SSI/EPIRB) Verification',
        fieldList: [
            {
                id: 'call-sign',
                label: 'Call Sign',
                type: 'text'
            },
            {
                id: 'telex-over-radio-no',
                label: 'Telex Over Radio (TOR) No.',
                type: 'text'
            },
            {
                id: 'mmsi-no',
                label: 'MMSI No (DSC/SSI/EPIRB)',
                type: 'text'
            },
            {
                id: 'mmsi-expiry-date',
                label: 'MMSI Expiry Date',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_INFORMATION,
        sectionName: 'Station Information',
        fieldList: [
            {
                id: 'vessel-name',
                label: 'Vessel Name',
                type: 'text'
            },
            {
                id: 'area-of-operation',
                label: 'Area of Operation',
                type: 'dropdown',
                apiID: 'CommonData'
            },
            {
                id: 'vessel-gross-tonnage',
                label: 'Vessel gross tonnage',
                type: 'dropdown',
                apiID: 'CommonData'
            },
            {
                id: 'month-year-built',
                label: 'Month / Year built',
                type: 'text'
            },
            {
                id: 'itu-nature-of-service',
                label: 'ITU nature of service',
                type: 'dropdown',
                apiID: 'CommonData',
                category:'CommonData'
            },
            {
                id: 'accounting-authority',
                label: 'Accounting Authority',
                type: 'dropdown',
                apiID: 'CommonData'
            },
            {
                id: 'station-information-remarks',
                label: 'Station Information Remarks',
                type: 'text',
                span: 12
            },
            {
                id: 'inmarsat-id-c',
                label: 'INMARSAT ID C',
                type: 'text',
                span: 12
            },
            {
                id: 'other-id-line-1',
                label: 'Other ID (line 1)',
                type: 'text'
            },
            {
                id: 'other-id-line-2',
                label: 'Other ID (line 2)',
                type: 'text'
            },
            {
                id: 'other-id-line-3',
                label: 'Other ID (line 3)',
                type: 'text'
            },
            {
                id: 'other-id-line-4',
                label: 'Other ID (line 4)',
                type: 'text'
            },
            {
                id: 'official-no',
                label: 'Official No.',
                type: 'text'
            },
            {
                id: 'vessel-type',
                label: 'Vessel Type',
                type: 'dropdown',
                apiID: 'CommonData'
            },
            {
                id: 'satellite-service',
                label: 'Satellite Service -  Is the ship equipped with satellite terminals?',
                type: 'text',
                span: 12
            },
            {
                id: 'purposes',
                label: 'Purposes',
                type: 'text',
                rule: {
                    baseIds: [`${STATION_INFORMATION}-satellite-service`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${STATION_INFORMATION}-satellite-service`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'brand-and-model',
                label: 'Brand and Model',
                type: 'text',
                rule: {
                    baseIds: [`${STATION_INFORMATION}-satellite-service`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${STATION_INFORMATION}-satellite-service`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'hours-of-service',
                label: 'Hours of service',
                type: 'dropdown',
                apiID: 'CommonData',
                span: 12
            },
            {
                id: 'start-time',
                label: 'Start Time',
                type: 'text'
            },
            {
                id: 'end-time',
                label: 'End Time',
                type: 'text'
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-use-of-system',
                label: 'Proposed Use of System',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
